import IconButton, { IconButtonShade } from "components/library/IconButton";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/outline";

interface Props {
  totalPages: number;
  currentPage: number;
}

export default function Pagination({ totalPages, currentPage }: Props) {
  const prevPage = currentPage - 1 > 0;
  const nextPage = currentPage + 1 <= totalPages;

  return (
    <div className="">
      <nav className="flex items-center gap-16">
        <IconButton
          size={40}
          shade={IconButtonShade.Gray}
          Icon={ArrowLeftIcon}
          disabled={!prevPage}
          href={prevPage ? `/blog/page/${currentPage - 1}` : undefined}
        />

        <span className="text-16-24">
          {currentPage} of {totalPages}
        </span>

        <IconButton
          size={40}
          shade={IconButtonShade.Gray}
          Icon={ArrowRightIcon}
          disabled={!nextPage}
          href={nextPage ? `/blog/page/${currentPage + 1}` : undefined}
        />
      </nav>
    </div>
  );
}
